// ============================================================
//  src/drive-errors.js — Mensajes de error Drive para la UI
// ============================================================

import { t } from './i18n.js';

export function mensajeErrorDrive(error, fallback = null) {
    const code = String(error?.code || '').toLowerCase();

    if (code === 'drive/session-expired')   return t('toast.drive.sesion-expirada');
    if (code === 'drive/not-authorized')    return t('toast.drive.no-autorizado');
    if (code === 'drive/access-revoked')    return t('toast.drive.acceso-revocado');
    if (code === 'drive/permission-denied') return t('toast.drive.sin-permisos');

    if (code.startsWith('drive/')) {
        return `${error.message}. ${t('toast.drive.error.fallback')}`;
    }

    return fallback ?? t('toast.drive.error.generico');
}
